import "./statusCardComponent.scss";

import React from 'react';

interface StatusCardComponentProps {
    className?: string;
    title: string;
    description?: string;
}

const StatusCardComponent = (props: React.PropsWithChildren<StatusCardComponentProps>) => {

    const {className, title, description, children} = props;

    return (
        <div className={`status-card-wrapper ${className}`}>
            <div className={"status-card-title"}>{title}</div>
            {
                description &&
                <div className={"status-card-description"}>{description}</div>

            }
            {
                children && <div className={"status-card-body"}>
                    {children}
                </div>
            }
        </div>
    );
};

export default StatusCardComponent;
